import Proxy from './Proxy';

export default class ResolveProxy extends Proxy {
  /**
   * The constructor for the ResolveProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('/ResolveActions', parameters);
  }

  /**
   * Method used to fetch resolve actions.
   *
   * @param {Object} data data to fetch ResolveActions details
   *
   * @returns {Promise} The result in a promise.
   */
  fetchResolveActions() {
    return this.submit('get', `${this.endpoint}`);
  }
}
